<p>blogs works!</p>
<app-bottom-menu></app-bottom-menu>
